import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h4 className="font-heading text-lg font-semibold text-background-50 mb-4">饭岛爱纪念网</h4>
              <p className="text-sm text-background-300 leading-relaxed">
                全面回顾饭岛爱的传奇人生与永恒影响力。她虽已离去，但她的勇气、她的文字、她对日本社会的影响，依然鲜活而有力。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">内容分类</h4>
              <ul className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/life-experience" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">
                    人生经历
                  </Link>
                </li>
                <li>
                  <Link to="/category/works" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer">
                    代表作品
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">关于本站</h4>
              <p className="text-sm text-background-300 leading-relaxed mb-4">
                本站为饭岛爱纪念性质的非商业网站，旨在保存和传播她的文化影响力。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-background-600 transition-colors cursor-pointer" aria-label="Twitter">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-background-600 transition-colors cursor-pointer" aria-label="Weibo">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-background-600 transition-colors cursor-pointer" aria-label="RSS">
                  <i className="ri-rss-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 饭岛爱纪念网 - 保留所有权利
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">使用条款</a>
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}